import {
  Box,
  Button,
  Divider,
  Grid,
  makeStyles,
  Typography
} from '@material-ui/core';
import { SendOutlined } from '@material-ui/icons';
import { useObserver } from 'mobx-react-lite';
import React, { FC } from 'react';
import { useOrdering } from '../../../stores/OrderingStore';
import { LayoutVariant } from '../../Core/CommonTypes';
import OrderDetail from './OrderDetail';

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    flexWrap: 'nowrap'
  },
  title: {
    flexGrow: 1,
    lineHeight: '2.4em'
  },
  note: {
    fontStyle: 'italic'
  },
  submitIcon: {
    margin: theme.spacing(1)
  },
  divider: {
    marginTop: 4,
    marginBottom: theme.spacing(1)
  },
  detail: {
    flex: '1 1 auto',
    overflowY: 'hidden',
    marginBottom: theme.spacing(1)
  }
}));

interface OrderDetailAreaProps {
  variant?: LayoutVariant;
  onSubmit?: () => void;
}

const OrderDetailArea: FC<OrderDetailAreaProps> = ({
  variant,
  onSubmit
}: OrderDetailAreaProps) => {
  const orderingStore = useOrdering();
  const classes = useStyles();
  return useObserver(() => (
    <Grid container direction="column" className={classes.container}>
      <Grid container direction="row">
        <Typography variant="h6" className={classes.title}>
          YOUR ORDER
        </Typography>
        {orderingStore.store.accept_order && (
          <Button
            disabled={orderingStore.order.subtotal === 0}
            variant="contained"
            color="primary"
            size="small"
            onClick={onSubmit}
          >
            <SendOutlined className={classes.submitIcon} />
            SUBMIT
          </Button>
        )}
      </Grid>
      {!orderingStore.store.accept_order && (
        <Typography
          variant="body2"
          color="textSecondary"
          className={classes.note}
          gutterBottom
        >
          NOTE: Store currently not accepting online order but you still can
          check how much would it cost for your ordering.
        </Typography>
      )}

      <Divider className={classes.divider} />
      <Box className={classes.detail}>
        <OrderDetail
          variant={variant}
          order={orderingStore.order}
          onDeleteItem={item => orderingStore.deleteItem(item)}
          onEditItem={item => orderingStore.editItem(item)}
          onItemChange={item => {
            orderingStore.onOrderItemUpdate(item);
          }}
          promotions={orderingStore.availablePromotions}
          onApplyCheapestPromotion={promotion =>
            orderingStore.applyCheapestPromotion(promotion)
          }
        />
      </Box>
    </Grid>
  ));
};

export default OrderDetailArea;
